import React from 'react';
import './componts.css';
import logo from './img/logo_no_bg.png';
import FloatingSingleCol from './FloatingSingleCol.jsx';

function Navbar() {
    return (
        <header className="site-header">
            <nav className="site-nav">
                {/* Left — logo + name */}
                <a href="/" className="site-nav__brand">
                    <img src={logo} alt="OctoNexus Power" className="site-nav__logo" />
                    <span className="site-nav__name">Octo<span style={{ color: '#0fa19a' }}>Nexus</span><br /><span className="site-nav__name-sub">Power</span></span>
                </a>

                {/* Right — links */}
                <div className="site-nav__links">
                    <a href="/about_us/who_we_are" className="site-nav__link">About Us</a>
                    <FloatingSingleCol
                        title="Technology"
                        href="/ourtechnology/HydroVerra"
                        links={[
                            { name: 'HydroVerra', icon: 'bi-lightning-charge-fill', href: '/ourtechnology/HydroVerra' },
                            { name: 'HydraCell',  icon: 'bi-battery-charging',      href: '/ourtechnology/HydraCell' },
                            { name: 'Zyraxon',    icon: 'bi-water',                 href: '/ourtechnology/Zyraxon' },
                        ]}
                    />
                    <FloatingSingleCol
                        title="Sectors"
                        href="/sectors"
                        twoCol
                        links={[
                            { name: 'EV Charging & Transport', icon: 'bi-ev-station',         href: '/sectors/ev-charging' },
                            { name: 'Events & Festivals',      icon: 'bi-music-note-beamed',  href: '/sectors/events' },
                            { name: 'Rural & Remote',          icon: 'bi-tree-fill',          href: '/sectors/rural-remote' },
                            { name: 'Ports, Marine & Vessels',        icon: 'bi-water',              href: '/sectors/ports-maritime' },
                            { name: 'Emergency & Resilience',  icon: 'bi-shield-fill-check',  href: '/sectors/emergency' },
                            { name: 'Construction Sites',            icon: 'bi-cone-striped',       href: '/sectors/construction' },
                            { name: 'Public Sector',           icon: 'bi-building',           href: '/sectors/public-sector' },
                            { name: 'Film & Production',       icon: 'bi-camera-video-fill',  href: '/sectors/film-production' },
                        ]}
                    />
                    <a href="/impact"      className="site-nav__link">Impact</a>
                    <a href="/news" className="site-nav__link">News</a>
                    <a href="/careers" className="site-nav__link">Careers</a>
                    <a href="/contactus" className="site-nav__cta">Get in Touch</a>
                </div>
            </nav>
        </header>
    );
}

export default Navbar;
